<template>
	<v-tooltip
		:top="top"
		:left="left"
		:bottom="bottom"
		:right="right"
		:disabled="disabled"
		:open-delay="250"
		color="grey darken-2"
		content-class="px-2 py-0"
	>
		<template v-slot:activator="{ on:tooltip, attrs }">
			<span v-bind="attrs" v-on="{...tooltip}">
				<slot></slot>
			</span>
		</template>
		<span class="text-caption"><slot name="text"></slot>{{text}}</span>
	</v-tooltip>
</template>

<script>
export default {
	props: {
		text: { type: String },
		top: { type: Boolean, default: true },
		left: { type: Boolean },
		bottom: { type: Boolean },
		right: { type: Boolean },
		disabled: { type: Boolean }
	}
}
</script>
